// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vm-modal h3[data-v-6c303ee5]{color:#3c3c46;font-family:Lato Bold,Helvetica,Arial,sans-serif;border-bottom:1px solid #3c3c46;padding-bottom:10px;margin-bottom:20px}.vm-modal h4[data-v-6c303ee5]{font-family:Lato Bold,Helvetica,Arial,sans-serif;color:#3c3c46}.vm-modal h4[data-v-6c303ee5],.vm-modal p[data-v-6c303ee5]{font-size:1.6rem;line-height:2rem;margin-top:10px}", ""]);
// Exports
module.exports = exports;
